import React, { Component } from 'react';
import logo from './mycme-logo_registered.svg';
import hmlogo from './Haymarket2019Logo.svg';
import './App.css';
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from './aws-exports';
import { Authenticator, SignUp } from 'aws-amplify-react';
import { Greetings } from 'aws-amplify-react/dist/Auth';
import Client from './components/Client';
import Admin from './components/Admin';
import ClientDisclaimer from './components/ClientDisclaimer'

Amplify.configure(awsconfig);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      group: ""
    };
  }

  componentDidUpdate() {
    if (this.props.authState === 'signedIn' && this.state.group === "") {

      const getGroup = async () => {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const currentSession = await Auth.currentSession();
        cognitoUser.refreshSession(await currentSession.getRefreshToken(), async (err, session) => {
            console.log('err', err);
            console.log('session', session);
            const accessToken = session.getAccessToken();

            const groups = accessToken.payload["cognito:groups"]
            this.setState({
              group: groups[0]
            });

            this.props.onAuth(this.state.group);
        });

      }

      getGroup();
    }
  }

  render() {
    if (this.props.authState !== 'signedIn') { return null; }
    
    return (
      <div>
        { this.state.group === "Clients" ? <Client authData={this.props.authData} /> : '' }
        { this.state.group === "Admins" ? <Admin /> : '' }
      </div>
    );
  }
}

class AppWithAuth extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authState: "",
      group: ""
    };
  }
  
  signOut = () => {
    Auth.signOut()
      .then(data => console.log(data))
      .catch(err => console.log(err));
  }

  setGroup = (groupName) => {
    this.setState({ group: groupName });
  }

  render() {
    return (
      <div className="App">
        <div className="header">
          <img src={logo} className="App-logo" alt="MyCME logo" />
          {
            (this.state.group === "Clients") ? 
              <ClientDisclaimer />
            : ""
          }
          {
            (this.state.authState === "signedIn") ? 
              <div className="header-right">
                <button href="#" onClick={() => this.signOut()}>Sign Out</button>
              </div> 
            : ""
          }
        </div>
        <Authenticator
          onStateChange={(authState) => this.setState({ authState: authState })}
          hide={[SignUp, Greetings]}>
          <App onAuth={this.setGroup} />
        </Authenticator>
        <footer>
          <img src={hmlogo} className="HM-logo" alt="Haymarket Logo" />
          <span>© 2023 Haymarket Media, Inc.</span>
          <a href="https://www.haymarketmediaus.com/haymarket-media-mycme-privacy-policy/">Privacy Policy</a>   
          <a href="https://www.haymarketmediaus.com/haymarket-media-inc-terms-and-conditions-of-service/">Terms and Conditions</a>
        </footer>
      </div>
    );
  }
}

export default AppWithAuth;